import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import TraderDetail from "@/pages/TraderDetail";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App font-ui">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/watch" element={<Dashboard spectator />} />
          <Route path="/traders/:id" element={<TraderDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
